import type { HelpFile } from '../../types/help'
import { EffectiveAccessBySystemTestIds } from '../../../testids/EffectiveAccessBySystemTestIds'

export const effectiveAccessBySystemHelp: HelpFile = {
  docPage: '/docs/analytics/effective-access',
  texts: {
    [EffectiveAccessBySystemTestIds.effectiveAccessBySystemPage]: 'Effective access broken down by target system — drill into a system to see identities and their grants.',
    [EffectiveAccessBySystemTestIds.colActions]: null,
    [EffectiveAccessBySystemTestIds.colEnvironment]: 'Environment in which the target system is deployed (production, staging, etc.).',
    [EffectiveAccessBySystemTestIds.colSystem]: null,
    [EffectiveAccessBySystemTestIds.colType]: 'Type of target system (LDAP, SCIM, database, etc.).',
  },
}
